<template>
  <div class="inviteBtn" :style="bgStyle" @click="handleClick"></div>
</template>

<script>
import { mapActions } from 'vuex';
import shareMixin from '../mixins/share';
export default {
  props: {
    buttonImage: {
      type: String,
      require: true
    },
    shareUrl: {
      type: String,
      require: true
    },
    moduleName: {
      type: String,
      require: true
    }
  },
  mixins: [shareMixin],
  computed: {
    bgStyle: function() {
      return {
        backgroundImage: `url("${this.buttonImage}")`
      };
    }
  },
  mounted() {
    this.$emit('reportEvent', {
      event: 'enterprise_points_expo',
      module_name: '邀请模块'
    });
  },
  methods: {
    ...mapActions('app', {
      doShareTask: function(dispatch) {
        return dispatch(`${this.moduleName}/doShareTask`);
      },
      actTimeCheck: function(dispatch) {
        return dispatch(`${this.moduleName}/actTimeCheck`);
      },
      refreshTaskInfo: function(dispatch) {
        return dispatch(`${this.moduleName}/refreshTaskInfo`);
      }
    }),
    reloadPage() {
      location.reload();
    },
    async handleClick() {
      this.reportClickInvite();
      const isBetweenActTime = await this.actTimeCheck();
      if (!isBetweenActTime) {
        return;
      }
      this.reportShareExpo();
      try {
        const target = await this.launchShare({ url: this.shareUrl });
        this.listenPageVisible(this.reloadPage.bind(this));
        this.reportChoseShareTarget(target);
        await this.doShareTask();
      } catch (err) {
        if (err && err.msg) {
          this.$hll.toast(err.msg);
        }
      }
    },
    listenPageVisible(cb) {
      document.addEventListener(
        'visibilitychange',
        function onVisibilitychange() {
          if (document.visibilityState === 'visible') {
            document.removeEventListener(
              'visibilitychange',
              onVisibilitychange
            );
            cb && cb();
          }
        }
      );
    },
    reportShareExpo() {
      this.$emit('reportEvent', {
        event: 'enterprise_points_expo',
        module_name: '分享组件'
      });
    },
    reportClickInvite() {
      this.$emit('reportEvent', {
        event: 'enterprise_points_click',
        module_name: '邀请模块',
        button_name: '邀请：（邀好友赚积分）'
      });
    },
    reportChoseShareTarget(target) {
      const targetNameMap = {
        wechat1: '微信好友W',
        wechatn: '朋友圈P'
      };
      this.$emit('reportEvent', {
        event: 'enterprise_points_click',
        module_name: '邀请分享',
        button_name: targetNameMap[target]
      });
    }
  }
};
</script>

<style>
.inviteBtn {
  width: 100%;
  height: 130px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
